(() => {
  const config = document.querySelector('#FuntoLanguageContext');
  if (!config) return;
  let context;
  try { context = JSON.parse(config.textContent); } catch { return; }
  const available = new Set([...context.available, context.current, 'en']);
  const rules = {
    DE: ['de', 'en'], AT: ['de', 'en'], FR: ['fr', 'en'],
    ES: ['es', 'en'], IT: ['it', 'en'], NL: ['nl', 'en'],
    BE: ['nl', 'fr', 'de', 'en'], CH: ['de', 'fr', 'it', 'en'], LU: ['fr', 'de', 'en'],
    PT: ['pt-PT', 'en'], SE: ['sv', 'en'], DK: ['da', 'en'],
    FI: ['fi', 'en'], NO: ['nb', 'en'], PL: ['pl', 'en'],
    CZ: ['cs', 'en'], SK: ['sk', 'en'], GR: ['el', 'en'],
    JP: ['ja', 'en'], AE: ['ar', 'en'], SA: ['ar', 'en']
  };
  let explicitLocale = '';
  try { explicitLocale = sessionStorage.getItem('funto_locale_choice') || ''; } catch {}
  const prepare = (form, country) => {
    if (!form || !form.querySelector('[name="country_code"]')) return;
    const supported = (rules[country] || ['en']).filter(code => available.has(code));
    const keepCurrent = supported.includes(context.current) && (context.current !== 'en' || explicitLocale === 'en');
    const locale = keepCurrent ? context.current : supported[0] || 'en';
    let input = form.querySelector('input[name="locale_code"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'locale_code';
      form.append(input);
    }
    input.value = locale;
  };
  document.addEventListener('click', event => {
    const option = event.target.closest('a[data-value]');
    if (!option) return;
    if (/^[a-z]{2}(?:-[A-Za-z]+)?$/.test(option.dataset.value || '') && option.closest('localization-form form')) {
      explicitLocale = option.dataset.value;
      try { sessionStorage.setItem('funto_locale_choice', explicitLocale); } catch {}
      return;
    }
    if (!/^[A-Z]{2}$/.test(option.dataset.value || '')) return;
    const form = option.closest('localization-form form');
    if (form) prepare(form, option.dataset.value);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('select[name="country_code"]')) prepare(event.target.form, event.target.value);
  }, true);
})();
